// extracted by mini-css-extract-plugin
module.exports = {"priceWrapper":"DeA_dJLJ","condensed":"ip_04eJo","priceSkeleton":"ob7Rl3Ao"};